/**
 * Format a date string (ISO YYYY-MM-DD or full ISO timestamp) into DD/MM/YYYY.
 * Returns the original input unchanged if it cannot be parsed.
 */
export function formatDateDMY(value) {
  if (!value) return "";
  // Try to match YYYY-MM-DD anywhere at the start
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  // Fallback: try Date parsing
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  }
  return String(value);
}
